var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1156 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(1156 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1154.5 53.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.415,11.457A6.957,6.957,0,1,1,11.457,4.5a6.957,6.957,0,0,1,6.957,6.957Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.758,28.758,26.63,26.63l-1.655-1.655",
    transform: "translate(-7.604 -7.604)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.7bfc7a4e89de8782252121fae1462a99.svg";
export { ForwardRef as ReactComponent };